import { render, staticRenderFns } from "./courseTitleEditor.vue?vue&type=template&id=9751503a&scoped=true"
import script from "./courseTitleEditor.vue?vue&type=script&lang=js"
export * from "./courseTitleEditor.vue?vue&type=script&lang=js"
import style0 from "./courseTitleEditor.vue?vue&type=style&index=0&id=9751503a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9751503a",
  null
  
)

export default component.exports